export const geopoliticalAreaUrl =
  'https://services9.arcgis.com/C1LhdW9uSxO25Nh2/arcgis/rest/services/skyOGeopoliticalArea/FeatureServer/0';

export const lonLatAreaUrl =
  'https://services9.arcgis.com/C1LhdW9uSxO25Nh2/arcgis/rest/services/SkyOLonLatAreas/FeatureServer/0';

export const cesiumBaseMapUrl =
  'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer';
